import { createContext, Dispatch, SetStateAction } from 'react';

interface LanguageContextType {
    language: Record<string, string>;
    setLanguage: Dispatch<SetStateAction<Record<string, string>>>;
}

const LanguageContext = createContext<LanguageContextType>({ language: {}, setLanguage: () => { } });

export default LanguageContext;